import React from 'react';
import { Nav, NavDropdown, Col} from 'react-bootstrap'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faBullhorn } from '@fortawesome/free-solid-svg-icons'
// import { Icon, } from '@iconify/react';
// import freeCodeCamp from '@iconify/icons-fa/free-code-camp';


const ContentBar = ( ) => {
    return (
        <>
            <div className="TopNavbar">
                <Nav.Link href="/CAPN">CAPN</Nav.Link>
                <Nav.Link href="/cours">Cours </Nav.Link>
                <Nav.Link href="/competiton">Club de Compétiton</Nav.Link>
                <Nav.Link href="/camp">Camps de jour</Nav.Link>
                <Nav.Link href="/formation">Formation de sauvetage</Nav.Link>
                <Nav.Link href="/articles">Actualités</Nav.Link>
                <Nav.Link href="https://www.amilia.com/store/en/capn/shop/programs">Inscriptions</Nav.Link>
                <Nav.Link href="/contact">Contact</Nav.Link>


            </div>
            <Col lg={2} md={2} sm={2} className="SideBar nopadding">
                <NavDropdown title="CAPN" id="collasible-nav-dropdown">
                    <NavDropdown.Item href="/CAPN/emploi">Emploi</NavDropdown.Item>
                    <NavDropdown.Item href="/CAPN/histoire">Qu'est ce que le CAPN</NavDropdown.Item>
                    <NavDropdown.Item href="/CAPN/conseil-administration">Conseil Administration</NavDropdown.Item>
                    <NavDropdown.Item href="/CAPN/politiques">Politiques du C.A.P.N</NavDropdown.Item>
                    <NavDropdown.Item href="/CAPN/informations">Informations générales</NavDropdown.Item>

                </NavDropdown>
                <NavDropdown title="Cours" id="collasible-nav-dropdown" >
                    <NavDropdown.Item href="/cours/enfants">Cours pour enfants</NavDropdown.Item>
                    <NavDropdown.Item href="/cours/adultes">Cours pour adultes</NavDropdown.Item>
                </NavDropdown>
                <NavDropdown title="Club de Competiton" id="collasible-nav-dropdown">
                    <NavDropdown.Item href="/competiton/maitres-nageurs">Maîtres Nageurs</NavDropdown.Item>
                    <NavDropdown.Item href="/competiton/nage-synchronisee">Nage synchronisée</NavDropdown.Item>
                    <NavDropdown.Item href="/competiton/natation">Natation</NavDropdown.Item>
                    <NavDropdown.Item href="/competiton/sauvetage-sportif">Sauvetage sportif</NavDropdown.Item>
                    <NavDropdown.Item href="/competiton/resultats">Résultats des compétitons</NavDropdown.Item>
                </NavDropdown>
                <NavDropdown title="Camps de jour" id="collasible-nav-dropdown" className="fa fa-tint">
                    <NavDropdown.Item href="/camp/ete">Camps d'été</NavDropdown.Item>
                    <NavDropdown.Item href="/camp/hiver">Camps d'hiver</NavDropdown.Item>
                </NavDropdown>
                <NavDropdown title="Formation de sauvetage" id="collasible-nav-dropdown">
                    <NavDropdown.Item href="/formation/sauvetage">Formation de sauvetage</NavDropdown.Item>
                    <NavDropdown.Item href="/formation/requalification">Requalification sauvetage</NavDropdown.Item>
                </NavDropdown>
                <Nav.Link href="https://www.amilia.com/store/en/capn/shop/programs">Inscriptions</Nav.Link>
                <Nav.Link href="/articles">Actualités</Nav.Link>
                <Nav.Link href="/contact">Contact</Nav.Link>
            </Col>
        </>
    );
};

export default ContentBar;